export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12 2.5c.264 0 .518.105.705.291l6.53 6.5.108.126a1 1 0 01.179.454c.392 3.015 1.43 6.292.456 10.839a1 1 0 01-.979.79H5a1 1 0 01-.977-1.21c.705-3.29.243-5.74-.196-8.31-.441-2.586-.855-5.286.218-8.774A1 1 0 015 2.5h7zm-6.24 2c-.675 2.673-.36 4.808.038 7.145.388 2.27.853 4.733.396 7.855h11.978c.552-3.325-.08-5.743-.508-8.5H12a1 1 0 01-1-1V4.5H5.76zM13 9h3.108l-3.109-3.094L13 9z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};